import api from './services/api';

// Armazenamento compartilhado via backend (PostgreSQL)
// Todos os usuários da agência leem e escrevem no mesmo banco — dados nunca somem.
//
// shared=false (padrão) → dados da agência, requer autenticação
// shared=true           → aprovações de clientes externos, sem autenticação

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

window.storage = {
  get: async (key, shared = false) => {
    try {
      if (shared) {
        // Rota pública — clientes aprovando sem login
        const res = await fetch(`${API_BASE}/storage/public/${encodeURIComponent(key)}`);
        if (!res.ok) return null;
        const data = await res.json();
        return data?.value !== undefined ? { value: data.value } : null;
      }

      // Rota autenticada — dados da agência
      const res = await api.get(`/storage/${encodeURIComponent(key)}`);

      if (res.data?.value !== undefined) return { value: res.data.value };

      // Backend vazio → migra localStorage automaticamente (primeira vez)
      const local = localStorage.getItem(key);
      if (local !== null) {
        console.log(`[storage] migrando "${key}" do localStorage → banco`);
        try {
          await api.post(`/storage/${encodeURIComponent(key)}`, { value: local });
          localStorage.removeItem(key); // só remove após confirmar gravação no banco
        } catch {}
        return { value: local };
      }

      return null;
    } catch (err) {
      // Fallback offline / dev sem backend
      const value = localStorage.getItem(key);
      return value !== null ? { value } : null;
    }
  },

  set: async (key, value, shared = false) => {
    try {
      if (shared) {
        // Rota pública — resultado de aprovação do cliente
        await fetch(`${API_BASE}/storage/public/${encodeURIComponent(key)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ value }),
        });
        return;
      }

      // Rota autenticada
      await api.post(`/storage/${encodeURIComponent(key)}`, { value });
    } catch {
      // Fallback: salva localmente se backend indisponível
      localStorage.setItem(key, value);
    }
  },
};
